
import React from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useParams } from "react-router-dom";

const SelectEtiquetas = ({ value, onChange }) => {
  const { id } = useParams();

  const loadOptions = async (inputValue) => {
    if (inputValue.length < 3) {
      return [];
    }

    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/producoes/etiquetas?restauranteId=${id}&nomeEtiqueta=${inputValue}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authentication": access_token
          },
        }
      );
      const data = await response.json();
      return data.map(item => ({
        value: item,
        label: item
      }));
    } catch (error) {
      console.error('Erro ao buscar etiquetas:', error);
      return [];
    }
  };

  const handleCreate = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    onChange(newOption);
  };

  return (
    <AsyncCreatableSelect
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions
      value={value}
      onChange={onChange}
      onCreateOption={handleCreate}
      formatCreateLabel={inputValue => `Criar nova etiqueta: "${inputValue}"`}
      placeholder="Digite para buscar ou criar uma etiqueta de produção"
      noOptionsMessage={({ inputValue }) =>
        inputValue.length < 3 ? "Digite pelo menos 3 caracteres" : "Nenhuma etiqueta encontrada"
      }
    />
  );
};

export default SelectEtiquetas;
